import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { history } from "./stores/configureStore";
import configureStore from "./stores/configureStore";
import { ConnectedRouter } from "connected-react-router";
import { BrowserRouter } from "react-router-dom";
import { msalConfig } from "./authConfig";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalProvider
} from "@azure/msal-react";
import { PersistGate } from "redux-persist/integration/react";
import WithAxios from "./components/Auth/withAxios";
import SignInListener from "./components/Auth/SignInListener";
import OutageSplash from "./outagesplash/OutageSplash";
import ImageModalProvider from "./global/contexts/ImageModalProvider";
import config from "devextreme/core/config";
import { licenseKey } from "./devextreme-license";

//Devextreme licensing
config({ licenseKey });

const App = React.lazy(() => import("./App"));
const StaffApp = React.lazy(() => import("./StaffApp"));

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback(event => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
      // set active account when loggin in from other tab/window
    } else if (event.eventType == EventType.ACCOUNT_ADDED && event.payload) {
      const account = event.payload;
      msalInstance.setActiveAccount(account);
    }
  });

  function handleResponse(response) {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      //msalInstance.loginRedirect();
    }
    if (response !== null) {
      msalInstance.setActiveAccount(response.account);
    }
  }

  msalInstance
    .handleRedirectPromise()
    .then(handleResponse)
    .catch(e => console.error(e));

  const store = configureStore();

  ReactDOM.render(
    // <React.StrictMode> Unsure why Kevin comment this out, this is bad practice.
    <OutageSplash>
      <BrowserRouter>
        <Provider store={store.store}>
          <PersistGate loading={null} persistor={store.persistor}>
            <MsalProvider instance={msalInstance}>
              <SignInListener>
                <WithAxios store={store} history={history}>
                  <ConnectedRouter history={history}>
                    <ImageModalProvider>
                      <AuthenticatedTemplate>
                        <Suspense fallback={<></>}>
                          <StaffApp />
                        </Suspense>
                      </AuthenticatedTemplate>
                      <UnauthenticatedTemplate>
                        <Suspense fallback={<></>}>
                          <App />
                        </Suspense>
                      </UnauthenticatedTemplate>
                    </ImageModalProvider>
                  </ConnectedRouter>
                </WithAxios>
              </SignInListener>
            </MsalProvider>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </OutageSplash>,
    // </React.StrictMode>
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
